import { css } from 'styled-components';
import globalStyles from 'gatsby-theme-core/src/components/form-elements/global-styles';

export default css`
  ${globalStyles}
  padding-top: .75rem;
  padding-bottom: .75rem;
  border-radius: ${({ theme }) => theme.borderRadius};
  line-height: ${({ theme }) => theme.baseLineHeight};
`;
